import React from 'react';

const LoadingSpinner = ({ size = 'medium', className = '' }) => {
    const sizeClasses = {
        small: 'w-4 h-4',
        medium: 'w-8 h-8',
        large: 'w-12 h-12'
    };

    return (
        <div className={`spinner ${sizeClasses[size]} ${className}`}></div>
    );
};

export default LoadingSpinner;